import { useEffect, useState, useRef } from "react";

export function useIntersectionObserver(
    { root = null, rootMargin, threshold = 0, once = false } = {},
    targetRef = null
) {
    const [isVisible, setIsVisible] = useState(false);
    const [intersectionRef, setIntersectionRef] = useState(targetRef);
    let observer = useRef();

    useEffect(() => {
        let targetNode = intersectionRef && intersectionRef.current;
        if (targetNode) {
            observer.current = new window.IntersectionObserver(
                ([entry], thisObserver) => {
                    setIsVisible(entry.isIntersecting);

                    if (entry.isIntersecting && once) {
                        thisObserver.disconnect();
                    }
                },
                { root, rootMargin, threshold }
            );
            observer.current.observe(targetNode);
        }

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [intersectionRef, once, root, rootMargin, threshold]);

    return [isVisible, setIntersectionRef];
}
